import { makeStyles } from "@material-ui/styles";
import { amber } from '@material-ui/core/colors';


export const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    button: {
        margin: theme.spacing(1),
    },
    warningButton: {
        backgroundColor: amber[700]
    },
    hidden: {
        display: 'none'
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    boldtext: {
        fontWeight: 'bold'
    },
    jobRadio: {
        marginLeft: 20,
    }
})

export default makeStyles(styles);